import React, { lazy, Suspense } from 'react';

const LazyAddMembersDTR = lazy(async () => await import('./AddMembersDTR'));

const AddMembersDTR = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyAddMembersDTR {...props} />
  </Suspense>
);

export default AddMembersDTR;
